<div class="row">
  <div class="col-12">
    <i class="icon-mat bi bi-file-text-fill"></i>
    <span class="secondary-details mr-2">{{ 'report.createReport.reports' | translate }}</span>
    <small class="text-danger text-right">
      {{ 'report.createReport.validationLabel' | translate }}
    </small>
  </div>
  <p class="setconfig-alert" *ngIf="setReportConfigAlert">
    {{ 'report.createReport.processingValidationLabel' | translate }}
  </p>
</div>

<div class="row mt-2" cdkDropListGroup>
  <div class="col-md-4">
    <div class="row">
      <div class="col-12">
        <div [formGroup]="reportsDetailsForm" class="rp-left-section">
          <div class="row">
            <div class="col-4 pe-0">
              <label class="required-field">
                {{ 'report.createReport.reportType' | translate }}:</label
              >
            </div>
            <div class="col-8">
              <mat-select
                class="form-control"
                placeholder="  {{ 'report.createReport.selectReportType' | translate }}"
                (selectionChange)="getReportParams($event)"
                formControlName="reportType">
                <mat-option [value]="">
                  {{ 'report.createReport.selectReport' | translate }}
                </mat-option>
                <mat-option *ngFor="let eachReport of reportTypesVal" [value]="eachReport.value">
                  {{ eachReport.type }}
                </mat-option>
              </mat-select>
              <app-error-component
                [controlName]="reportsDetailsForm.get('reportType')"></app-error-component>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-4 pe-0">
              <label class="required-field">
                {{ 'report.createReport.reportFormat' | translate }}
                :</label
              >
            </div>
            <div class="col-8 align-items-start">
              <mat-select
                class="form-control"
                placeholder="{{ 'report.createReport.selectReportFormat' | translate }}"
                formControlName="reportFormat">
                <mat-option [value]="">
                  {{ 'report.createReport.selectFormat' | translate }}
                </mat-option>
                <mat-option *ngFor="let rptFormat of reportFormatVal" [value]="rptFormat.value">
                  {{ rptFormat.type }}
                </mat-option>
              </mat-select>
              <app-error-component
                [controlName]="reportsDetailsForm.get('reportFormat')"></app-error-component>
            </div>
          </div>

          <div class="row mt-1 reports-date">
            <div class="col-4 mt-3 pe-0">
              <label class="required-field">
                {{ 'report.createReport.date' | translate }}
                :</label
              >
            </div>
            <div class="col-8 align-items-start">
              <mat-form-field class="custm-date">
                <!-- <mat-label>Enter a date range</mat-label> -->
                <mat-date-range-input [rangePicker]="picker" [max]="maxDate ? maxDate : today">
                  <input
                    type="text"
                    matStartDate
                    (dateChange)="setMaxDate()"
                    placeholder="{{ 'report.createReport.startDate' | translate }}"
                    formControlName="startDate"
                    readonly />
                  <input
                    type="text"
                    matEndDate
                    placeholder="{{ 'report.createReport.endDate' | translate }}"
                    formControlName="endDate"
                    readonly />
                </mat-date-range-input>
                <mat-hint>
                  {{ 'report.createReport.datePlaceholder' | translate }}
                </mat-hint>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker (closed)="resetMaxDate()" #picker></mat-date-range-picker>
              </mat-form-field>
              <div *ngIf="daysDiffError" class="color: red">
                {{ 'report.createReport.dateValidationLabel' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-4">
    <h5 class="ml-2">
      {{ 'report.createReport.availableColumns' | translate }}
    </h5>

    <div class="reportParam-container">
      <div
        style="height: 65vh; overflow-y: auto"
        cdkDropList
        id="cdk1"
        [cdkDropListData]="unMappedFields"
        class="reportParam-list"
        (cdkDropListDropped)="drop($event)">
        <div class="reportParam-box" *ngFor="let item of unMappedFields" cdkDrag>
          {{ item }}
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <h5 class="ml-2">
      {{ 'report.createReport.reportColumns' | translate }}
    </h5>
    <div class="reportParam-container">
      <div
        style="height: 65vh; overflow-y: auto"
        cdkDropList
        id="cdk2"
        [cdkDropListData]="mappedFields"
        class="reportParam-list"
        (cdkDropListDropped)="drop($event)">
        <div
          class="reportParam-box"
          *ngFor="let item of mappedFields"
          [ngClass]="{ 'required-field': isFieldMandatory(item) }"
          cdkDrag>
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</div>
<div class="btn-wrapper pb-0">
  <button
    class="primary-btn me-2"
    type="submit"
    [disabled]="
      !reportsDetailsForm.valid ||
      this.daysDiffError ||
      this.mappedFields.length == 0 ||
      this.setReportConfigAlert
    "
    (click)="generateReport()">
    {{ 'report.createReport.generateReport' | translate }}
  </button>
</div>
